// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper__XrK9O","title":"Radio_title__d8b3o"};